import { makeStyles } from '@material-ui/core';
import Logo from './GENIUS_SPORTS_HORIZONTAL_SMALL_WHITE_RGB.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 80,
    display: 'block',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src={Logo} alt="Genius Sports" />;
};

export default LogoFull;
